import { TypographyStyles } from '@/styles'
import { CONTRACTOR_PAYROLL_STEPS } from '../../helpers'
import { Progress, Text } from '@/ui'

export const ContractorPayrollHeader = ({
  currentTab,
}: {
  currentTab: number
}) => (
  <>
    <Text variant={TypographyStyles.H2}>Pay Contractors</Text>
    <Progress
      activeSegment={currentTab}
      variant="segmented"
      numberOfSegments={CONTRACTOR_PAYROLL_STEPS.length}
      segmentTitles={CONTRACTOR_PAYROLL_STEPS}
    />
  </>
)
